import React from "react";
import { Link } from "react-router-dom";
import { LuMapPin, LuPhone, LuMail, LuClock } from "react-icons/lu";
import { useAuth } from "../context/AuthContext";

const footerLinks = {
  Home: [
    { label: "Home",       href: "/" },
    { label: "FAQ",        href: "/faq" },
    { label: "Contact Us", href: "/contact" },
  ],
  Information: [
    { label: "Privacy Policy",      href: "/privacy-policy" },
    { label: "Terms & Conditions",  href: "/terms" },
    { label: "Shipping Policy",     href: "/shipping" },
    { label: "Return Policy",       href: "/return" },
    { label: "Disclaimers",         href: "/disclaimer" },
  ],
  Account: [
    { label: "Login / Register", href: "/login" },
    { label: "Forgot Password",  href: "/forgot" },
    { label: "My Account",       href: "/dashboard" },
    { label: "Checkout",         href: "/checkout" },
  ],
};

const contactInfo = [
  { Icon: LuMapPin, text: "Dallas, TX"                      },
  { Icon: LuPhone,  text: "(214) 635-6340", href: "tel:2146356340" },
  { Icon: LuMail,   text: "khojadistributions@gmail.com", href: "mailto:khojadistributions@gmail.com" },
  { Icon: LuClock,  text: "Mon–Sat: 10am–6pm"              },
];

function Footer() {
  const { user } = useAuth();

  const resolvedFooterLinks = {
    ...footerLinks,
    Account: user
      ? footerLinks.Account.filter(({ href }) => href !== "/login")
      : footerLinks.Account,
  };

  return (
    <footer className="bg-brand-navy text-slate-400 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-12 pb-8">

        {/* Age / regulatory disclaimer */}
        <p className="text-[11px] text-center text-slate-600 mb-10 border-b border-white/5 pb-8 leading-relaxed max-w-3xl mx-auto">
          NOT FOR SALE TO MINORS &nbsp;|&nbsp; CALIFORNIA PROPOSITION 65 — This product contains nicotine, a chemical known to the State of California to cause birth defects or other reproductive harm.
        </p>

        {/* Link columns */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 text-sm mb-12">
          {Object.entries(resolvedFooterLinks).map(([section, links]) => (
            <div key={section}>
              <h3 className="text-white font-bold text-xs uppercase tracking-widest mb-4" style={{ fontFamily: "Lexend, sans-serif" }}>
                {section}
              </h3>
              <ul className="space-y-2.5">
                {links.map(({ label, href }) => (
                  <li key={label}>
                    <Link
                      to={href}
                      onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
                      className="hover:text-brand-amber transition-colors text-sm"
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Support column */}
          <div>
            <h3 className="text-white font-bold text-xs uppercase tracking-widest mb-4" style={{ fontFamily: "Lexend, sans-serif" }}>
              Support
            </h3>
            <address className="not-italic space-y-3">
              {contactInfo.map(({ Icon, text, href }) => (
                <div key={text} className="flex items-start gap-2.5">
                  <Icon size={14} className="text-brand-amber flex-shrink-0 mt-0.5" />
                  {href ? (
                    <a href={href} className="hover:text-brand-amber transition-colors text-sm leading-tight">
                      {text}
                    </a>
                  ) : (
                    <span className="text-sm leading-tight">{text}</span>
                  )}
                </div>
              ))}
            </address>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/5 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-600">
          <span>© {new Date().getFullYear()} Khoja Distributions. All rights reserved.</span>
          <span className="hidden sm:block">DFW, Texas · B2B Wholesale</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
